export default __webpack_public_path__ + "static/media/hz528.1ebde8ea.svg";